module.exports = __webpack_public_path__ + "4e550cb1a0b951f05d64d2363561b7f8.svg";